// ru_RU.js
import React from "react";
const ru_RU = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
    // Основные компоненты
    "XiaDanTiXing": "Напоминание о заказе",
    "NH_GDDBH_": "В заказе есть товары с предварительной ценой. Пожалуйста, дождитесь подтверждения клиента перед оплатой. Подтвердить заказ?",
    "QueRenXiaDan": "Подтвердить заказ",
    "WoZaiKanKan": "Посмотрю позже",
    "XSQBDZ": "Показать все адреса",
    // Чат/Комнаты
    "ZBZCBQFH": "Смайлы не поддерживаются",
    "FaSongLianJie": "Отправить ссылку",
    "YiChangXiaoXi": "Ошибка сообщения",
    "QingShuRu": "Введите текст",
    "FaSong": "Отправить",
    // Дата/Время
    "DQSJXYKSSJ": "Текущее время раньше начала",
    "DQSJCGJSSJ": "Текущее время позже окончания",
    "QuXiao": "Отмена",
    "NianYueRi": "ГГГГ.ММ.ДД",
    "ShiFen": "ЧЧ:мм",
    "QueDing": "Подтвердить",
    "Nian": "Год",
    "Yue": "Месяц",
    "Ri": "День",
    "Shi": "Час",
    "Fen": "Минута",
    // Товары/Акции
    "Qi": "от",
    "1GeCuXiao": "1 акция",
    "ChaKanZengPin": "Посмотреть подарки",
    "JHDJSHS_1T": "До конца акции: {d}д {h}ч {m}м {s}с",
    "YHGZ_ZPBKD": "Правила: подарки не суммируются",
    "YHGZ_AZZGM": "Правила: скидка на итоговое кол-во",
    "GuanBi": "Закрыть",
    // Фильтры
    "QuanBu": "Все",
    "ZWXGSJ": "Нет данных",
    "ZuiDiJia": "Минимальная цена",
    "ZuiGaoJia": "Максимальная цена",
    "LeiXing": "Тип",
    "PinPai": "Бренд",
    "BiaoQian": "Теги",
    "JiaGeQuJian": "Диапазон цен",
    "SPMC_GG_BH_": "Название / Хар-ки / Код",
    "ZuHeShaiXuan": "Фильтр",
    "ChongZhi_CanShu": "Сбросить",
    // Изображения
    "ZDKSC1ZTP": "Макс. {num} фото",
    "ZYXSCTP": "Только изображения",
    "SCTPDXBYXC": "Размер фото не более {size}",
    "QBYCFSCTP_": "Не загружайте дубликаты",
    "ShangChuanChengGong": "Успешно загружено",
    "ZDKSC1Z": "Макс. {num}",
    // Клавиатура/Корзина
    "CCSLZDXZ": "Превышен лимит",
    "QiDingLiang": "Мин. заказ",
    "ShouQi": "Свернуть",
    "ShanChu": "Удалить",
    // Заказы
    "Dai": "Ожидает",
    "YiQuXiao": "Отменен",
    "ZengPin": "Подарок",
    "1Zhong": "{num} вид(а)",
    "1Jian": "1 шт.",
    "HeJi": "Итого",
    "DaiFu": "Ожидает оплаты",
    // Прочее
    "_DDM1YZ1J_": "[Заказ от {targetPrice}₽ +{presentNum}шт]",
    "_DDM1YLJ1Y_": "[Заказ от {targetPrice}₽ -{price}₽]",
    "_DDM1YLX1Z_": "[Заказ от {targetPrice}₽ скидка {discount}%]",
    "DingDanCuXiao": "Акции заказа",
    "DLCKJG": "Войдите для просмотра цен",
    "DianPuZhuYe": "Главная магазина",
    "GouWuChe": "Корзина",
    "ZaiXianKeFu": "Чат",
    "GeRenZhongXin": "Профиль",
    "LianXiDianHua": "Телефон",
    "FanHuiDingBu": "В начало",
    "ZBDYML": "Страница не найдена",
    "KNWZCW_HZY": "Неправильная ссылка или страница удалена",
    "FanHuiShangJi": "Назад",
    "FanHuiShouYe": "На главную",
    "SFQRSCSP": "Удалить товар?",
    "QueRen": "Подтвердить",
    "YiChuShangPin": "Удалить товар",
    "XiuGai": "Изменить",
    "DaiQueRen": "Ожидает подтверждения",
    "DaiFaHuo": "Ожидает отправки",
    "DaiShouHuo": "Ожидает получения",
    "YiWanCheng": "Завершен",
    "YiZuoFei": "Аннулирован",
    "DaiShenHe": "Ожидает проверки",
    "DaiHeXiao": "Ожидает сверки",
    "YiHeXiao": "Сверка пройдена",
    "XianXiaZhiFu": "Офлайн-оплата",
    "ZhiNengDaoZhangShiBie": "Банковский перевод (автосверка)",
    "WeiXinZhiFu": "WeChat Pay",
    "KqZhiFu": "Kuaiqian Pay (WeChat/Alipay)",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "Баланс",
    "HuoDaoFuKuan": "Оплата при получении",
    "DaiTuiHuo": "Ожидает возврата",
    "DaiTuiKuan": "Ожидает возврата средств",
    "ChuangJianDingDan": "Создать заказ",
    "BianJiDingDan": "Редактировать заказ",
    "TiJiaoDingDan": "Оформить заказ",
    "DingDanShenHe": "Проверка заказа",
    "CaiWuShenHe": "Финансовая проверка",
    "BoHui": "Отклонить",
    "TianJiaShouKuan": "Добавить оплату",
    "ZaiXianZhiFu": "Онлайн-оплата (WeChat/Alipay/JD Pay/UnionPay)",
    "YinLianZhiFu": "UnionPay",
    "MercadoPagoZhiFu": "Mercado Pago",
    "ShouKuanShenHe": "Проверка оплаты",
    "ShouKuanZuoFei": "Аннулировать оплату",
    "ChuKu": "Отгрузка",
    "ChuKuShenHe": "Проверка отгрузки",
    "FaHuo": "Отправить",
    "TianJiaWuLiu": "Добавить трек-номер",
    "XiuGaiWuLiu": "Изменить трек-номер",
    "ChuKuZuoFei": "Аннулировать отгрузку",
    "ShouHuo": "Получить заказ",
    "DingDanHeZhun": "Подтверждение заказа",
    "QuXiaoDingDan": "Отменить заказ",
    "CJTHD": "Создать возврат",
    "DaYin": "Печать",
    "DaoChu": "Экспорт",
    "DingDanWanCheng": "Заказ завершен",
    "QiangZhiWanCheng": "Принудительное завершение",
    "DingDanZuoFei": "Аннулировать заказ",
    "MaiZeng": "Подарок за покупку",
    "ZhiJiang": "Прямая скидка",
    "DaZhe": "Скидка %",
    "YuShou": "Предзаказ",
    "DingDanManZeng": "Подарок за сумму заказа",
    "DingDanManJian": "Скидка за сумму заказа",
    "DingDanManZhe": "Скидка % за сумму заказа",
    "XinRenQuan": "Новичкам",
    "ManJianQuan": "Скидка за сумму",
    "ShangPinQuan": "Товарный купон",
    "DaiJieSuan": "Ожидает расчета",
    "YiJieSuan": "Рассчитано",
    "QuanBuShangPin": "Все товары",
    "TuiJianShangPin": "Рекомендуемые",
    "XinPin": "Новинки",
    "ReXiaoShangPin": "Популярные",
    "ChangYongShangPin": "Часто покупаемые",
    "DaiShouKuan": "Ожидает оплаты",
    "BuFenShouKuan": "Частично оплачен",
    "YiShouKuan": "Оплачен",
    "BXYFP": "Без чека",
    "ZZSPTFP": "Обычный НДС-чек",
    "ZZSZYFP": "Спец. НДС-чек",
    "QiTaFaPiao": "Другой чек",
    "XianXia": "Офлайн",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Предоплата",
    "XianXiaZhuangZhang": "Банковский перевод",
    "XianShangZhiFu": "Онлайн-оплата",
    "YCKZF": "Оплата балансом",
    "DaiTiJiao": "Ожидает оформления",
    "KuaiDi": "Курьер",
    "SongHuoShangMen": "Доставка",
    "ShangMenZiQu": "Самовывоз",
    "WuLiuHuoYun": "Грузоперевозка",
    "QiTa": "Другое",
    "YouHuo": "В наличии",
    "WuHuo": "Нет в наличии",
    "SJCW_QLXKF": "Ошибка данных. Обратитесь в поддержку",
    "ShangJia": "В продаже",
    "YiXiaJia": "Снят с продажи",
    "YiJinYong": "Отключен",
    "YiQiYong": "Активен",
    "YiTingYong": "Приостановлен",
    "KeHuZhuCe": "Регистрация клиента",
    "XinZengDaoRu": "Импорт",
    "DDDSH": "Ожидает проверки",
    "DCWSH": "Ожидает фин.проверки",
    "DaiChuKu": "Ожидает отгрузки",
    "DCK_BF_": "Ожидает отгрузки (частично)",
    "DFH_BF_": "Ожидает отправки (частично)",
    "DSH_BF_": "Ожидает получения (частично)",
    "DSK_BF_": "Ожидает оплаты (частично)",
    "WTHSQ": "Нет запросов на возврат",
    "THDSH": "Ожидает проверки возврата",
    "THCLZ": "Обработка возврата",
    "THYWC": "Возврат завершен",
    "DYDHD": "Печать заказа",
    "DYFHD": "Печать накладной",
    "DCDHD": "Экспорт заказа",
    "DCFHDWE_P": "Экспорт накладной в Excel/PDF",
    "TuiDanZuoFei": "Аннулировать возврат",
    "DTHSH": "Ожидает проверки возврата",
    "DaiRuKu": "Ожидает приема",
    "DRK_BF_": "Ожидает приема (частично)",
    "DFK_BF_": "Ожидает оплаты (частично)",
    "ChuangJianTuiDan": "Создать возврат",
    "BianJiTuiDan": "Редактировать возврат",
    "TiJiaoTuiDan": "Оформить возврат",
    "TuiHuoShenHe": "Проверка возврата",
    "RuKu": "Прием",
    "RuKuShenHe": "Проверка приема",
    "RuKuZuoFei": "Аннулировать прием",
    "TianJiaFuKuan": "Добавить оплату",
    "FuKuanZuoFei": "Аннулировать оплату",
    "FuKuanShenHe": "Проверка оплаты",
    "TuiDanWanCheng": "Возврат завершен",
    "QiTaChuKu": "Другая отгрузка",
    "XiaoShouChuKu": "Отгрузка продаж",
    "PanKuiChuKu": "Отгрузка недостачи",
    "DiaoBoChuKu": "Перемещение",
    "CaiGouTuiHuo": "Возврат поставщику",
    "TuiHuoRuKu": "Прием возврата",
    "CaiGouRuKu": "Прием поставки",
    "QiTaRuKu": "Другой прием",
    "PanYingRuKu": "Прием излишков",
    "DiaoBoRuKu": "Прием перемещения",
    "CJCGD": "Создать закупку",
    "BJCGD": "Редактировать закупку",
    "TJCGD": "Оформить закупку",
    "CGDZF": "Аннулировать закупку",
    "CGDWC": "Закупка завершена",
    "CGTHZF": "Аннулировать возврат поставки",
    "CGTHWC": "Возврат поставки завершен",
    "THDDY": "Печать возврата",
    "THDDC": "Экспорт возврата",
    "CKDDY": "Печать отгрузки",
    "CKDDC": "Экспорт отгрузки",
    "GLDZH": "Аккаунт управления",
    "DHDZH": "Аккаунт закупок",
    "ShenHeTongGuo": "Проверка пройдена",
    "SHBTG": "Проверка не пройдена",
    "WuXuFaPiao": "Без чека",
    "DaiKeXiaDan": "Заказ от имени",
    "ZiZhuXiaDan": "Самостоятельный заказ",
    "PCShangCheng": "PC Магазин",
    "APPShangCheng": "APP Магазин",
    "TVShangCheng": "TV Магазин",
    "WeiXinShangCheng": "WeChat Магазин",
    "ShouJiShangCheng": "Мобильный магазин",
    "ADDXSMLTC": "Комиссия за маржу",
    "ADDXSSRTC": "Комиссия за выручку",
    "AKHSSYG": "По прикрепленному клиенту",
    "AnZhiDanRen": "По создателю",
    "ATHJEBLKCT": "Вычет из комиссии по сумме возврата",
    "DDYTHBJXTC": "Нет комиссии при возврате",
    "DaiDaKuan": "Ожидает выплаты",
    "WeiKaiShi": "Не началось",
    "JinXingZhong": "В процессе",
    "YiGuoQi": "Истекло",
    "Yi": "млн",
    "QianWan": "10 млн",
    "BaiWan": "млн",
    "Wan": "тыс.",
    "Sheng1Tian": "Остался 1 день",
    "Sheng1XiaoShi": "Остался 1 час",
    "Miao": "сек",
    "1Miao": "1 сек",
    "GangGang": "Только что",
    "1FenZhongQian": "1 мин назад",
    "1XiaoShiQian": "1 час назад",
    "1TianQian": "1 день назад",
    "1GeYueQian": "1 мес назад",
    "1NianQian": "1 год назад",
    "WeiZhiLeiXing": "Неизвестный тип",
    "YYGBCDSP_K": "Отличный товар! Посмотрите",
    "ZanWeiSheZhi": "Не настроено",
    "HQWXSQXX": "Получить данные авторизации WeChat",
    "JGJYYDMBQ": "Масштаб по мета-тегу",
    "NLJZZ": "Загрузка...",
    "ShangPinMingXi": "Детали товара",
    "ShangPinLeiBie": "Категории",
    "QXZFPNR": "Выберите содержание чека",
    "QXZFPLX": "Выберите тип чека",
    "QTXFPTT": "Введите название для чека",
    "FaPiaoTaiTou": "Название для чека",
    "NSRSBH": "ИНН",
    "FaPiaoNeiRong": "Содержание чека",
    "FaPiaoXinXi": "Информация о чеке",
    "KaiJuFaPiao": "Выставить чек",
    "FaPiaoLeiXing": "Тип чека",
    "Han": "С",
    "WeiHan": "Без",
    "Shui": "налог",
    "QSRFPTT": "Введите название для чека",
    "QSRNSRSBH": "Введите ИНН",
    "YiManZu_Man": "Условие выполнено: [от",
    "ZaiGou": "Докупить",
    "YMZ_DHJJZ": "Условие выполнено: [Цена от",
    "JianJiangZhi": "шт. по цене",
    "YMZ_YDHJD": "Условие выполнено: [Скидка",
    "JianMeiJian": "шт. по",
    "SYTCSLW0_WFJRGWC": "Наборов нет. Невозможно добавить в корзину",
    "QingXuanXeShangPin": "Выберите товары!",
    "GSPYXJ": "Товар снят с продажи!",
    "ZJ2TN": "Последние 2 дня",
    "QDQCXJSP": "Удалить снятые с продажи товары?",
    "QingChuChengGong": "Очистка успешна",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Наборы нельзя добавить в корзину. Сначала удалите их",
    "SPSLBN": "Количество товара не может",
    "TaoCanHan": "Включает",
    "TaoCan": "Набор",
    "QHDSL": "Проверьте количество",
    "SPSLBNDY": "Количество товара не может быть ниже",
    "XianDingLiang": "Лимит",
    "YiRuShouCang": "В избранное",
    "QuanXuan": "Выбрать все",
    "JianZeng": "шт. в подарок",
    "JianLiXiang_Man": "шт. [от",
    "Yuan_": "₽]",
    "Zhe_": "%]",
    "KCBZ_WFJRGWC": "Нет в наличии. Невозможно добавить",
    "XDJEDYDY": "Сумма заказа от",
    "WYXJHYSXDSP": "Нет снятых или неактивных товаров!",
    "DYQDL": "Ниже мин. заказа",
    "ZSPG1J": "{count} вида(ов), {number} шт.",
    "WanCheng": "Готово",
    "BianJi": "Изменить",
    "You": "Есть",
    "ZSPBFHYQ_W": "видов товаров не соответствуют требованиям. Нажмите, чтобы увидеть",
    "SPSLBNGY": "Количество товара не может быть выше",
    "JXDJ_CKXYGBFHYQSP": "Нажмите еще раз для следующего несоответствия",
    "XiaDan": "Оформить",
    "JianJiang": "шт. со скидкой",
    "QRYCSP": "Удалить товар?",
    "QXZXDSP": "Выберите товары для заказа",
    "KCBZ_QCXXZ": "Нет в наличии. Выберите заново!",
    "KuCun": "Наличие",
    "YCKXD": "₽ для заказа",
    "QDSCSP": "Добавить в избранное?",
    "ShouCangChengGong": "Добавлено в избранное",
    "GYXDL": "Выше лимита",
    "LiSheng": "Экономия",
    "GWCHSKD_QGYGB": "Корзина пуста. Начните покупки!",
    "QuGuangGuang": "Начать покупки",
    "QCXJSP": "Удалить снятые товары",
    "ZongE": "Итого",
    "YouHui": "Скидка",
    "QXZJHRQ": "Выберите дату доставки",
    "FuJiaFeiYong": "Доп. сборы",
    "ZhongShangPin_Gong": "видов, всего",
    "PeiSongShiJian": "Время доставки",
    "QXZPSSJ": "Выберите время доставки",
    "DingDanJinE": "Сумма заказа",
    "SCFJ_ZD4Z": "Загрузите файлы (макс. {num}, каждый до {size})",
    "KeYongShangPin": "Доступные товары",
    "ShiYongShuoMing": "Инструкция",
    "YouXiaoQi": "Срок действия",
    "Man": "от",
    "BZZBZCTSFH": "Заметки: спецсимволы не поддерживаются",
    "QingXuanZe": "Выберите",
    "KaiPiaoXuJia": "Доплата за чек",
    "PeiSongFangShi": "Способ доставки",
    "ShangPinZongJia": "Сумма товаров",
    "YouHuiQuan": "Купоны",
    "ZhangKeXan": "доступно",
    "DDJEWMZ": "Сумма заказа не достигла",
    "WDYHQ": "Мои купоны",
    "KYYHQ": "Доступные купоны",
    "YuanKeYong": "₽ доступно",
    "ChaKanDingDan": "Посмотреть заказ",
    "ShangPinHanShui": "Товар с налогом",
    "SPWHS": "Товар без налога",
    "GeDian": "%",
    "QueRenDingDan": "Подтвердить заказ",
    "XZSHDZ": "Добавить адрес",
    "ShangPinQingDan": "Список товаров",
    "WKYYHQ": "Нет доступных купонов",
    "HuChi": "Конфликтует",
    "DaiJinQuan": "Подарочный сертификат",
    "YunFei": "Доставка",
    "ShuiFei": "Налог",
    "WKYYY": "Причина недоступности",
    "YHQYGQ": "Купон истек",
    "WDYHQSYSJ": "Время использования еще не наступило",
    "ZDSPJEWMZ": "Сумма товара не достигла",
    "BKYYHQ": "Недоступные купоны",
    "RMBJE": "Сумма в RMB",
    "QXZPSFS": "Выберите способ доставки",
    "1ZSP_G": "1 вид, всего",
    "YSSP_YJ": "Предзаказ, ожидаемая",
    "JiaoHuoRiQi": "Дата доставки",
    "GMJLY": "Сообщение продавцу",
    "ZhengZaiChuLi...": "Обработка...",
    "FSCSP": "Товар не из магазина",
    "ZZCLTXM": "Обработка штрих-кода...",
    "SPTJCG": "Товар добавлен",
    "QSTXM": "Отсканируйте штрих-код",
    "SFSCDQSP": "Удалить этот товар?",
    "BQ_ZBDXGSP": "Извините, товар не найден",
    "XuanZeDanWei": "Выберите единицу",
    "JRGWC": "В корзину",
    "QXXZDJRSP": "Сначала выберите товар",
    "ZhengZaiChuLi": "Обработка",
    "JRGWCCG": "Добавлено в корзину",
    "ZanWuShangPin": "Нет товаров",
    "XTYJBNFZSP": "Ссылка на товар скопирована!",
    "NKYHDDYDYJ": "Вы получите комиссию в «Мои",
    "LiChaKan": "»",
    "WeiXinHaoYou": "Друзья WeChat",
    "ErWeiMa": "QR-код",
    "CASBEWM": "Отсканируйте QR-код",
    "FZSB_QCXFZ": "Ошибка копирования. Попробуйте снова!",
    "TWEWM": "QR-код с текстом",
    "BCDXC": "Сохранить в галерею",
    "CATPBCDXC": "Нажмите и удерживайте для сохранения",
    "FuZhiLianJie": "Копировать ссылку",
    "FXZYJ": "Поделиться и заработать",
    "YJZGKZQYJ": "Макс. комиссия",
    "FXSPGLSKH": "Поделиться товаром",
    "FXHJSCNZSD": "Создайте свой мобильный магазин с настраиваемыми ценами и контактами.",
    "WSCDQJG_ND": "Цена в магазине: Ваша цена ×",
    "DaiSheZhi": "Не настроено",
    "PengYouQuan": "Моменты WeChat",
    "GGFXSZ": "Изменить настройки",
    "QXSRZH": "Введите логин",
    "MMGSCW_6_20W": "Неверный формат пароля (6-20 букв/цифр)",
    "BDYYZH": "Привязать аккаунт",
    "WXKJDL": "Быстрый вход через WeChat",
    "BangDingZhangHao": "Привязать аккаунт",
    "YYZH_QDL": "Уже есть аккаунт? Войти",
    "ZCXZH": "Зарегистрироваться",
    "HuanYingNi": "Добро пожаловать",
    "ZH_SJHM": "Логин/Телефон",
    "MiMa": "Пароль",
    "QDLHCZ": "Требуется вход",
    "DengLuGuoQi": "Сессия истекла",
    "DLGQ_QCXDL": "Сессия истекла. Войдите снова",
    "KCBZ_BNTJG": "Нет в наличии. Нельзя добавить больше",
    "ZhiFuChengGong": "Оплата успешна!",
    "ZFSB_QCXCS": "Ошибка оплаты. Попробуйте снова!",
    "QXXZGG": "Сначала выберите характеристики",
    "SXGGX": "Выбранные характеристики требуют",
    "GMSLXYQDL_": "Количество ниже мин. заказа. Выберите заново!",
    "GMSLDYXDL_": "Количество выше лимита. Выберите заново!",
    "ShangPinBianHao": "Артикул",
    "QiDing": "Мин. заказ",
    "SXGGDGSLBK": "Превышен лимит заказа для выбранных характеристик",
    "KCBZ_BNTJ": "Нет в наличии. Нельзя добавить",
    "QXXZSP": "Сначала выберите товар",
    "SLBNW0": "Количество не может быть 0",
    "QXZGG": "Выберите характеристики",
    "LiJiYuDing": "Забронировать",
    "ShouYe": "Главная",
    "ShangPin": "Товары",
    "DingDan": "Заказы",
    "WoDe": "Профиль",
    "ZhiFuQuXiao": "Оплата отменена",
    "ShangPinYongJin": "Комиссия за товар",
    "YaoQingJiangLi": "Бонус за приглашение",
    "TiXian": "Вывод средств",
    "TiXianBoHui": "Вывод отклонен",
    "ZhuanWeiYuE": "Перевести на баланс",
    "Jin7Tian": "7 дней",
    "Jin30Tian": "30 дней",
    "ShouZhiMingXi": "История операций",
    "ZanWuShuJu": "Нет данных",
    "WoDeKeHu": "Мои клиенты",
    "WoDeYaoQing": "Мои приглашения",
    "LeiJiKeHu": "Всего клиентов",
    "LeiJiDingDan": "Всего заказов",
    "YaoQingHaoYou": "Пригласить друзей",
    "LeiJiYaoQing": "Всего приглашено",
    "LJSY_Y_": "Общий доход (₽)",
    "BHDJS": "Включая ожидающие",
    "J7TSY_Y_": "Доход за 7 дней (₽)",
    "J7TXZKH_R_": "Новые клиенты за 7 дней (чел)",
    "KTXYJ": "Доступно к выводу",
    "XYJYO": "Продолжайте в том же духе",
    "ChangJianWenTi": "Частые вопросы",
    "Q_ZMYJX_TG": "В: Как «зарабатывать на продвижении»?",
    "A_FXDPND_Z_": "О: Делитесь ссылками на товары с иконкой «₽». При регистрации/покупке по вашей ссылке вы получите комиссию.",
    "Q_RHJS_TGZ": "В: Как рассчитывается комиссия?",
    "A_MGD_Z_TBD": "О: У каждого товара с иконкой «₽» есть процент комиссии. Комиссия рассчитывается от итоговой суммы заказа (после скидок/доставки).",
    "Q_TGZQ_DSY": "В: Когда поступает комиссия?",
    "A_HYTGNDFX": "О: После получения заказа клиентом комиссия переводится на ваш счет.",
    "Q_LJKH_LJY": "В: Почему нет аватаров/имен в списках?",
    "A_WXYQZYGZ": "О: WeChat требует официальную подписку для данных. Если магазин не верифицирован, подпишитесь на «云上订货».",
    "Q_WSMWASSG": "В: Почему не получил комиссию?",
    "A_1_HYKNBW": "О: 1) Клиент не привязан к вам; 2) Ссылка открыта вне WeChat без cookies; 3) Свяжитесь с поддержкой.",
    "XiaoShouZhongXin": "Центр продаж",
    "SPMC_GG_BH": "Название / Хар-ки / Артикул",
    "YuJiZhuan": "Ожидаемый доход",
    "YaoQingKa": "Пригласительная карта",
    "YNYQJR_TGY": "Присоединяйтесь и зарабатывайте",
    "DJBCDXC": "Сохранить в галерею",
    "JYQKFSGHY_": "Поделитесь картой с друзьями",
    "HuanYingJiaRu": "Добро пожаловать",
    "YQNCW": "Приглашаем стать",
    "LiJiJiaRu": "Присоединиться",
    "YuJiYongJin": "Ожидаемая комиссия",
    "YongJin": "Комиссия",
    "YuJiJiangLi": "Ожидаемый бонус",
    "JiangLi": "Бонус",
    "SPTGDD": "Заказы по продвижению",
    "YQJLDD": "Заказы по приглашениям",
    "YeJiTongJi": "Статистика продаж",
    "LJKH_R_": "Всего клиентов (чел)",
    "SPYJ_Y_": "Комиссия за товар (₽)",
    "HanDaiJieSuan": "Включая ожидающие",
    "XGMCJS": "Термины",
    "KeHu": "Клиент",
    "HFXYBDLKHG": "Покупатель, привязанный к продавцу",
    "YaoQing": "Приглашение",
    "FXYCGYQDXJ": "Приглашенный продавец",
    "FXYTJKHGMH": "Комиссия от клиента",
    "XJFXYTGSPH": "Бонус от приглашенного",
    "NiCheng": "Имя",
    "HaiBaoTuiGuang": "Рекламный постер",
    "JHBFSGHY_T": "Поделитесь постером с друзьями",
    "JieSuanZhongXin": "Центр выплат",
    "KTXJE": "Доступно к выводу",
    "TiXianJiLu": "История выплат",
    "KHRXMBNWK": "Имя держателя обязательно!",
    "KHHBNWK": "Банк обязателен!",
    "YHKHBNWK": "Номер карты обязателен!",
    "SFZTPBNWK": "Фото паспорта обязательно!",
    "YHKTPBNWK": "Фото карты обязательно!",
    "BaoCunChengGong": "Сохранено!",
    "SCSFZ": "Загрузить паспорт",
    "SCYHK": "Загрузить карту",
    "BaoCun": "Сохранить",
    "TiXianZhangHu": "Счет для вывода",
    "TS_QTXZSXX": "Важно: Укажите реальные данные для проверки.",
    "KHRXM": "Имя держателя",
    "KaiHuHang": "Банк",
    "YinhangKaHao": "Номер карты",
    "QSRZSXM": "Введите реальное имя",
    "QSRKHHMC": "Введите название банка",
    "QSRYHKH": "Введите номер карты",
    "QXSZTXZH": "Сначала настройте счет для вывода",
    "QuSheZhi": "Настроить",
    "JEXY10Y_BKT": "Меньше 10₽. Нельзя вывести!",
    "JECGKTXJE": "Превышает доступную сумму!",
    "CGDRKTXSX_": "Превышен дневной лимит (макс. 20000₽ в день)!",
    "QueDingJiang": "Подтвердить перевод",
    "ZhuanDaoYuE": "на баланс?",
    "1_JEDY10YSB": "1. Минимум 10₽ для вывода;",
    "2_BCTXDZSJ": "2. Вывод занимает до 5 рабочих дней. Лимит: 20000₽/день;",
    "3_GBSRWHSS": "3. Доход облагается налогом. Самостоятельно уплатите НДФЛ;",
    "4_ZDYEKYYS": "4. Баланс можно использовать в магазине;",
    "TXSQCG_QDD": "Запрос на вывод принят. Ожидайте проверки",
    "JEDYKTXJE_": "Превышает доступную сумму. Нельзя перевести!",
    "ZZYECG_QDG": "Перевод на баланс успешен. Проверьте в профиле!",
    "BenCiTiXian": "Эта выплата",
    "ZhuangDaoYuE": "На баланс",
    "TiXianDao": "Вывод на",
    "JEW0BKZZYE": "Сумма 0. Нельзя перевести!",
    "DRTXSX2WY": "Лимит: 20000₽/день",
    "QuanBuTiXian": "Вывести всё",
    "QueRenTiXian": "Подтвердить вывод",
    "ZuiChangGouMai": "Часто покупаемые",
    "MoRenPaiXu": "По умолчанию",
    "ZongHe": "Рекомендуемые",
    "FenLei": "Категории",
    "XiaoLiangYouXian": "По популярности",
    "XiaoLiang": "Продажи",
    "JiaGe": "Цена",
    "ShaiXuan": "Фильтр",
    "ZuiJinGouMai": "Недавние покупки",
    "CuXiaoYouXian": "По акциям",
    "QuanBuFenLei": "Все категории",
    "ZhiKanCuXiao": "Только акции",
    "XuanZeFenLei": "Выбрать категорию",
    "QXZFL": "Выберите категорию",
    "ZWXGSP": "Товаров не найдено",
    "PinPaiHui": "Бренды",
    "TuiJianFenLei": "Рек. категории",
    "ShangPinFenLei": "Категории товаров",
    "GengDuo": "Ещё",
    "DLZHBSDQQY": "Аккаунт не принадлежит текущему клиенту",
    "GXNHQ": "Поздравляем! Вы получили",
    "SZWSCJGH_C": "Настройте цену для публикации",
    "JHDJSHS_": "До конца акции:",
    "DLHKFX": "Требуется вход для публикации",
    "ZZHQXX_QSH": "Получение данных. Повторите позже",
    "Zhang": "",
    "Tian": "дн",
    "QXZGGZQPD": "Выберите характеристики",
    "Yuan": "₽",
    "XS_F_M": "чч/мм/сс",
    "WoDeJiFen": "Мои баллы",
    "DaBaiLe": "Вы лучше",
    "JiFen": "баллов",
    "DeHuiYuan": "пользователей",
    "ZhuanJiFen": "Заработать баллы",
    "JiFenMingXi": "История баллов",
    "HuanLiPin": "Обменять подарки",
    "CKGDHL": "Смотреть все подарки",
    "ChaDingDan": "Мои заказы",
    "DHSLBNCG": "Не более {num} для обмена",
    "DuiHuanShuLiang": "Кол-во для обмена",
    "SuoXuJiFen": "Требуется баллов",
    "LiPinXiangQing": "Детали подарка",
    "WoYaoDuiHuan": "Обменять",
    "ShengYu": "Осталось",
    "TuWenXiangQing": "Описание",
    "YiDuiWan": "Распродано",
    "FenLeiShaiXuan": "Фильтр по категориям",
    "JiFenShaiXuan": "Фильтр по баллам",
    "JiFenShouRu": "Начислено",
    "JiFenZhiChu": "Списано",
    "DingDanGenZong": "Отслеживание",
    "WuLiuGongSi": "Курьерская служба",
    "WuLiuDanHao": "Трек-номер",
    "DingDanLieBiao": "Список заказов",
    "YiFaHuo": "Отправлено",
    "JiFenDingDan": "Заказы за баллы",
    "ChaKanWuLiu": "Отследить",
    "LPSLBZ_QCX": "Недостаточно подарков. Попробуйте снова",
    "JiFenBuZu": "Недостаточно баллов",
    "ZhiFuXinXi": "Оплата",
    "JiXuGuangGuang": "Продолжить покупки",
    "QTXSHXX": "Введите адрес доставки",
    "DuiHuanChengGong": "Успешный обмен",
    "LPDHQR": "Подтверждение обмена",
    "SCCKJ": "Рыночная цена",
    "LiJiZhiFu": "Оплатить",
    "DingDanXiangQing": "Детали заказа",
    "DingDanZhuangTai": "Статус заказа",
    "DingDanBianHao": "Номер заказа",
    "DuiHuanShiJian": "Время обмена",
    "ShouHuoXinXi": "Адрес доставки",
    "HuaFeiJiFen": "Потрачено баллов",
    "QDZJF": "Заработать баллы за вход",
    "XDZJF": "Заработать баллы за заказ",
    "DDWCHKHDYD": "После получения заказа получите баллы = Сумма заказа *",
    "1_MRQD_JL": "1. Ежедневный вход: +",
    "2_LXQD3T_EW": "2. 3 дня подряд: +",
    "3_LXQD7T_EW": "3. 7 дней подряд: +",
    "BeiDeJiFen": "x баллов",
    "DLZJF": "Заработать баллы за вход",
    "MeiRiDengLu": "Ежедневный вход",
    "SC_JL": "магазин: +",
    "GuiZe": "Правила",
    "QianDaoYouLi": "Бонус за вход",
    "QianDaoGuiZe": "Правила входа",
    "YLXQD": "Подряд вошли",
    "QDCG_NYJLX": "Успешный вход! Вы вошли",
    "QDCG_BCHD": "Успешный вход! Получено",
    "QSRBZ": "Введите заметку",
    "DingDanZengPin": "Подарок к заказу",
    "GuiGeBianHao": "Артикул характеристики",
    "GuiGe": "Характеристика",
    "CDDWXFK": "Этот заказ не требует оплаты",
    "YHYEBZ": "Недостаточно средств на балансе!",
    "ZFJEBNW0": "Сумма оплаты не может быть 0!",
    "ZFJEBNDYDD": "Сумма оплаты превышает задолженность",
    "DFKJE": "К оплате",
    "FuKuanFangShi": "Способ оплаты",
    "FuJian": "Файл",
    "ZHYFZ": "Аккаунт скопирован",
    "GHSKZH": "Изменить счет",
    "SYXXZFQSCF": "Для офлайн-оплаты загрузите скриншот для подтверждения.",
    "XXZF_BXXZS": "Для офлайн-оплаты выберите счет",
    "DingDanZhiFu": "Оплата заказа",
    "ZFFS_HDFK": "Оплата при получении",
    "BCFKJE": "Эта оплата",
    "YuE": "Баланс",
    "FuZhiZhangHao": "Копировать реквизиты",
    "WSZXCXZFPZ": "Настройки оплаты для мини-программы не заданы",
    "XCXZFZHJY": "Аккаунт оплаты для мини-программы отключен",
    "SRZFJE": "Введите сумму",
    "FuKuanZhangHu": "Счет для оплаты",
    "QueRenZhiFu": "Подтвердить оплату",
    "ShaoHouZhiFu": "Оплатить позже",
    "FKJLYTJ_DD": "Оплата добавлена. Ожидает проверки",
    "JiXuGuang": "Продолжить покупки",
    "BenCiFuKuan": "Эта оплата",
    "FuKuanChengGong": "Оплата успешна",
    "ZhiFuFangShi": "Способ оплаты",
    "ZhiFuDingDan": "Оплатить заказ",
    "QXXZSXZFDD": "Сначала выберите заказы для оплаты",
    "PiLiangFuKuan": "Оплатить всё",
    "FuKuan": "Оплатить",
    "'QuFuKuan'": "Оплатить",
    "YingFuJinE": "К оплате",
    "XiaDanShiJian": "Время заказа",
    "SFQRSH": "Подтвердить получение?",
    "DDQRSH_": "Подтвердить получение заказа?",
    "DFHSP": "Товары к отправке",
    "ShangPinShuLiang": "Количество товаров",
    "ChuKuShiJian": "Время отгрузки",
    "FaHuoShiJian": "Время отправки",
    "WuLiuBeiZhu": "Примечание к доставке",
    "QueRenShouHuo": "Подтвердить получение",
    "RYFK_QJSYG": "Если оплатили, свяжитесь с администратором",
    "QSRQXYY": "Введите причину отмены",
    "H_DDJZDGB_QJKF": "Заказ будет отменен через {time}. Оплатите быстрее.",
    "TuiHuoQingKuang": "Возврат",
    "DingDanZongE": "Сумма заказа",
    "DingDanBeiZhu": "Примечание",
    "FaHuoQingKuang": "Отправка",
    "DingDanFuJian": "Файлы заказа",
    "ShenQingTuiHuo": "Запросить возврат",
    "G1TDSHJL_QRS": "Подтвердить получение {num} товаров?",
    "DaiXiaDan": "Заказ от имени",
    "DingDanHao": "Номер заказа",
    "XiaDanFangShi": "Способ заказа",
    "TuiHuoDan": "Возврат",
    "ShangPinZongE": "Сумма товаров",
    "YunFei_ZongZhong": "Доставка (вес",
    "SF_SPWS": "Налог (товар без налога",
    "TePiJia": "Особая цена",
    "FuKuanQingKuang": "Оплата",
    "TiaoJiLu": "записей",
    "ZaiLaiYiDan": "Повторить заказ",
    "QDSCGDD_": "Удалить этот заказ?",
    "YiQueRen": "Подтвержден",
    "YiShouHuo": "Получен",
    "DaiFuJinE": "К оплате",
    "YiFuJinE": "Оплачено",
    "ZanWuJiLu": "Нет записей",
    "SPMC_DDH": "Название / Номер заказа",
    "FuKuanZhuangTai": "Статус оплаты",
    "FaHuoZhuangTai": "Статус отправки",
    "QiShiShiJian": "Начало",
    "ZhongZhiShiJian": "Конец",
    "CaoZuoChengGong": "Успешно",
    "ZBKGM": "Недоступно",
    "DQDDSPYXJ": "Товары в заказе сняты с продажи",
    "DQDDBFSPYXJ": "Часть товаров в заказе снята с продажи",
    "JTJSJSP": "Добавить только доступные",
    "DingHuoDan": "Заказ",
    "DingDanRiZhi": "История заказа",
    "FuZhiChengGong": "Скопировано",
    "FuZhiShiBai": "Ошибка копирования",
    "FuZhi": "Копировать",
    "BoDa": "Позвонить",
    "WCWLDHXX": "Нет данных по треку",
    "ZFCS_QCXXD": "Время оплаты истекло. Оформите заново",
    "YQYYCKZF": "Оплата балансом включена",
    "BNDYDFKJE": "Не может превышать сумму к оплате",
    "ZFJEBNWK": "Сумма оплаты обязательна",
    "QXAPFK_FKH": "Оплатите и загрузите подтверждение для сверки",
    "DDTJCG_QJS": "Заказ оформлен. Оплатите быстрее",
    "QXZFKFS": "Выберите способ оплаты",
    "SYYEZFH_HX": "После оплаты балансом осталось оплатить",
    "FuKuanJiLu": "История оплаты",
    "ZWFKJL": "Нет оплат",
    "FuKuanXiangQing": "Детали оплаты",
    "FuKuanJinE": "Сумма",
    "ZhiDan": "Создано",
    "ShenHe": "Проверка",
    "ZuoFei": "Аннулировано",
    "ZuoFeiYuanYin": "Причина аннулирования",
    "GLDHD": "Связанный заказ",
    "HeXiaoJinE": "Сумма сверки",
    "HeXiaoZhuangTai": "Статус сверки",
    "DanJuZhuangTai": "Статус",
    "KeHuMingCheng": "Клиент",
    "ZhangDanHao": "Номер счета",
    "ShouKuanZhangHao": "Счет для оплаты",
    "ShouKuanShiJian": "Время оплаты",
    "FuKuanPingZheng": "Подтверждение оплаты",
    "GeFuJian": "файл(ов)",
    "DingDanTongJi": "Статистика заказов",
    "DingHuo": "Закупка",
    "Bi": "",
    "DDTJMX": "Детали статистики",
    "AGGTJ": "По характеристикам",
    "AFLTJ": "По категориям",
    "DDJE_Y": "Сумма заказа/₽",
    "DHSP_Z": "Товаров",
    "DingHuoDan_Bi": "Заказов",
    "DingHuoShangPin": "Закупленные товары",
    "JinE": "Сумма",
    "TuiHuo": "Возврат",
    "THDHWBC_QD": "Возврат не сохранен. Уйти?",
    "QSRSQTHJE": "Введите сумму возврата",
    "QSRTHJE": "Введите сумму возврата",
    "QSRBZXX": "Введите примечание",
    "YingTuiJinE": "Сумма к возврату",
    "TJTHSQ": "Отправить запрос",
    "QXXZDHQD": "Сначала выберите заказ",
    "DingHuoQingDan": "Список заказа",
    "SQTHJE": "Запрошенная сумма",
    "DJXZSP": "Выбрать товары",
    "TuiHuoJinE": "Сумма возврата",
    "THDDXQ": "Детали возврата",
    "YiTuiHuo": "Возвращен",
    "YiTuiKuan": "Возвращено",
    "THDZT": "Статус возврата",
    "TuiHuoDanHao": "Номер возврата",
    "TuiHuoShiJian": "Время возврата",
    "TuiHuoCangKu": "Склад возврата",
    "THLXR": "Контакт возврата",
    "TuiHuoQingDan": "Список возврата",
    "TuiKuanZongE": "Итого к возврату",
    "TuiKuanQingKuang": "Возврат средств",
    "DaiTuiJinE": "К возврату",
    "YiTuiJinE": "Возвращено",
    "SPMC_BH_GG": "Название / Артикул / Код хар-ки / Штрих-код",
    "GZD1TJG": "Найдено 1 результат",
    "JiaRuQingDan": "Добавить в список",
    "ShenQingChengGong": "Успешно отправлено",
    "THDTJCG": "Запрос на возврат оформлен",
    "ChaKanXiangQing": "Подробнее",
    "HDWKS_WDZL": "Акция еще не началась",
    "HDYJS_XCZD": "Акция завершена",
    "ZWSZBT": "Нет заголовка",
    "ChaKanGengDuo": "Смотреть больше",
    "HCDZSJC": "Расхождение из-за кеша",
    "DLCKCXJ": "Войдите для просмотра цены",
    "ZWSZCX": "Нет акций",
    "JuKaiShi": "До начала",
    "Song": "В подарок",
    "JuJieShu": "До конца",
    "YiJieShu": "Завершено",
    "XiaoXi": "Уведомления",
    "SaoMaXiaDan": "Заказ по QR-коду",
    "WZLCSJ": "Неизвестные данные",
    "QXZYSDHAPP": "Скачайте приложение 云上订货",
    "QMTYQYGLD": "Полная версия для бизнеса",
    "XZYSDHAPP": "Скачать 云上订货",
    "HQGLDWZTY": "Полная версия управления",
    "JXTYDHD": "Продолжить в закупках",
    "GongGaoXiangQing": "Детали уведомления",
    "GongGaoFuJian": "Файлы уведомления",
    "NFWDYMBCZO": "Страница не найдена",
    "KeNengYuanYin": "Возможные причины",
    "1_ZDZLSRCWD": "1. Неверный адрес;",
    "2_DJLGQLJ": "2. Просроченная ссылка.",
    "GuanLiDuan": "Управление",
    "ZhuCe": "Регистрация",
    "HYNTYYSDH": "Добро пожаловать в 云上订货",
    "TYZHSJHDQG": "Данные тестовых аккаунтов периодически сбрасываются. Не вводите важную информацию.",
    "TYZHZDNRSJ": "Данные тестовых аккаунтов фиктивны. Не вводите важную информацию.",
    "ZHZCCG": "Регистрация успешна",
    "DengLuZhangHao": "Логин",
    "CSMMW": "Пароль по умолчанию:",
    "GNFYHQL": "Вам отправлен купон!",
    "Man1YuanKeYong": "от {num}₽",
    "LQH1TNKY": "Действителен {day} дней",
    "YiJianLingQu": "Получить",
    "GXNHD1ZYHQ": "Вы получили купон",
    "Gong1Yuan": "1₽",
    "LiJiShiYong": "Использовать",
    "NHWDL": "Вы не вошли",
    "ShangChengGongGao": "Уведомления магазина",
    "ZanWuGongGao": "Нет уведомлений",
    "1GeFuJian": "{num} файл(ов)",
    "KouKuan": "Списание",
    "ChongZhi_Kuan": "Пополнение",
    "KouKuanZuoFei": "Аннулировать списание",
    "ChongZhiZuoFei": "Аннулировать пополнение",
    "ZhangHuMingXi": "История счета",
    "ZhangHuYuE": "Баланс",
    "LiJiChongZhi": "Пополнить",
    "CZJEBNXY1Y": "Минимум 1₽",
    "QSRZQDSZ": "Введите число",
    "ZDYJE": "Другая сумма",
    "ZWKTXSCZGN": "Онлайн-пополнение недоступно",
    "ShiFuJinE": "Итого к оплате",
    "ZhangHuChongZhi": "Пополнение счета",
    "QXZCZJE": "Выберите сумму",
    "QSRCZJE": "Введите сумму",
    "QLXNDZSYWY": "Свяжитесь с менеджером для пополнения",
    "ShouJia": "Цена",
    "YiShouQing": "Распродано",
    "ChongZhiJinE": "Сумма пополнения",
    "QueRenFuKuan": "Подтвердить оплату",
    "QSDDID": "Нет ID заказа",
    "ChongZhiChengGong": "Пополнение успешно",
    "ChongZhiShiBai": "Ошибка пополнения",
    "CLZ_QSH...": "Обработка...",
    "ChongZhiFangShi": "Способ пополнения",
    "ChongZhiShiJian": "Время пополнения",
    "JYLSH": "Номер транзакции",
    "FanHuiShangCheng": "В магазин",
    "ZFSB_QCS": "Ошибка оплаты. Попробуйте снова",
    "ZFYQX": "Оплата отменена",
    "ZFYC_QCS": "Ошибка оплаты. Попробуйте снова",
    "LingQuanZhongXin": "Центр купонов",
    "WeiShiYong": "Не использовано",
    "YiShiYong": "Использовано",
    "ZWYHQ": "Нет купонов",
    "YiGouMai": "Куплено",
    "ChangYongQingDan": "Избранные списки",
    "WoDeShouCang": "Мои избранные",
    "QuGouWuChe": "В корзину",
    "GeShangPin": "товар(ов)",
    "YunShangDingHuo": "云上订货",
    "QSRZH": "Введите логин!",
    "QSRMM": "Введите пароль!",
    "QSRDLZH": "Введите логин",
    "JiZhuMiMa": "Запомнить пароль",
    "WangJiMiMa": "Забыли пароль?",
    "DengLu": "Войти",
    "DLZHBCZ_QL": "Аккаунт не существует. Обратитесь к администратору",
    "GQYZHSBJY_": "Аккаунт отключен. Обратитесь в поддержку",
    "GQYZHSYQJS_": "Тестовый период закончен. Обратитесь в поддержку",
    "GQYZHYGQL_": "Срок действия аккаунта истек. Требуется продление",
    "LiJiTiYan": "Попробовать",
    "YiChuChengGong": "Удалено",
    "QueHuo": "Нет в наличии",
    "YCSCJ": "Удалить из избранного",
    "SheZhiChengGong": "Настройки сохранены",
    "ZWWDXX": "Нет непрочитанных",
    "QuanBuYiDu": "Прочитать всё",
    "DingDanXiaoXi": "Уведомления о заказах",
    "YiQiang": "Уже взято",
    "LiJiLingQu": "Получить",
    "LingQuanHou": "После получения",
    "TianNeiKeYong": "дней действия",
    "QSRSJH": "Введите телефон",
    "QSRYZM": "Введите код",
    "QSRXMM": "Введите новый пароль",
    "QSRZQSJGS": "Неверный формат телефона",
    "ChongZhiMiMa": "Сбросить пароль",
    "QSRNDSJHM": "Введите ваш телефон",
    "QSRDXYZ": "Введите SMS-код",
    "HQYZM": "Получить код",
    "HKCXHQ": "Повторная отправка через",
    "QSR6_20WSZHZ": "Пароль: 6-20 букв/цифр",
    "QSRSPJGBL": "Введите коэффициент цены",
    "SPJGBLBXDY": "Коэффициент: от 100 до 999.99",
    "DPMCZBZCTS": "Название магазина: спецсимволы не допускаются",
    "LXRZBZCTSF": "Контактное лицо: спецсимволы не допускаются",
    "LXFSZBZCTS": "Контактные данные: спецсимволы не допускаются",
    "LXDZZBZCTS": "Адрес: спецсимволы не допускаются",
    "DPJJZBZCTS": "Описание: спецсимволы не допускаются",
    "QSRDPJJ_ZD": "Описание (макс. 50 символов)",
    "FenXiangSheZhi": "Настройки публикации",
    "NDWSCSPJG": "Цена в вашем магазине",
    "NDDHJ_": "Ваша цена ×",
    "LXXX_KBJ_": "Контакты (редактируемые)",
    "DianPuMingCheng": "Название магазина",
    "JianJie": "Описание",
    "QSRDPMC": "Введите название",
    "LianXiRen": "Контактное лицо",
    "QSRLXR": "Введите имя",
    "LianXiFangShi": "Контакты",
    "QSRLXFS": "Введите контакты",
    "LianXiDiZhi": "Адрес",
    "QSRLXDZ": "Введите адрес",
    "WoDeDingDan": "Мои заказы",
    "ZuiJinLiuLan": "Недавно просмотренные",
    "ShouCangShangPin": "Избранные товары",
    "BDYYZH_ZC": "Привязать аккаунт | Зарегистрироваться",
    "DL_ZC": "Войти | Регистрация",
    "BangDingShouJi": "Привязать телефон",
    "TS_BDSJHM_": "Привяжите телефон для безопасности",
    "ChaKanQuanBu": "Смотреть всё",
    "ShouHuoDiZhi": "Адреса доставки",
    "LianXiWoMen": "Связаться",
    "SheZhi": "Настройки",
    "QuQianDao": "Войти",
    "JiFenShangCheng": "Магазин баллов",
    "TuiGuangShangPin": "Рекомендовать товары",
    "QuChaKan": "Подробнее",
    "JiFenHuanLi": "Обмен баллов",
    "DYSPBQ": "Печать этикеток",
    "GYYSDH": "О приложении",
    "YQHYSMEWM_": "Отсканируйте QR-код для скачивания",
    "DangQianBanBen": "Текущая версия",
    "ZWSHDZ": "Нет адресов",
    "WoDeDiZhi": "Мои адреса",
    "ZhiNengShiBie": "Автораспознавание",
    "ZTDZXXKZNS": "Вставьте адрес для автораспознавания имени/телефона/адреса",
    "MoRen": "По умолчанию",
    "QRSCDZ": "Удалить адрес?",
    "SHRXM": "Получатель",
    "SJHMHGDDHZ": "Укажите телефон",
    "QSRSHRXM": "Введите имя получателя",
    "ShouJiHaoMa": "Телефон",
    "GuDingDianHua": "Стационарный телефон",
    "QSRGDDH": "Введите телефон",
    "SuoZaiDiQu": "Регион",
    "QSRSZDQ": "Введите регион",
    "QSRXXDZ": "Введите адрес!",
    "QSRZQDSJHM": "Неверный телефон",
    "QSRZQDGDDH": "Неверный стационарный телефон",
    "XiangXiDiZhi": "Адрес",
    "MoRenDiZhi": "Адрес по умолчанию",
    "SWMRDZ": "Сделать основным",
    "BCBSY": "Сохранить и использовать",
    "QSRSJHM": "Введите телефон",
    "GYHYZC": "Аккаунт уже зарегистрирован",
    "GSJHMYJZCG": "Телефон уже зарегистрирован",
    "QZJDLJK": "Войдите напрямую",
    "QuDengLu": "Войти",
    "BDHKYTGSJH": "Привяжите телефон для входа и восстановления пароля",
    "_BDHKYTGSJ": "*Привяжите телефон для входа и восстановления пароля",
    "QSRSJYZM": "Введите SMS-код",
    "BDXSJ": "Привязать новый телефон",
    "DXYZM": "SMS-код",
    "XiaYiBu": "Далее",
    "TGCBZ": "Пропустить",
    "DBDSJHMBCZ": "Телефон не существует!",
    "QSRDLMM": "Введите пароль!",
    "_GSJHMYBDY": "*Телефон уже привязан к другому аккаунту. Введите пароль для привязки.",
    "DQZHMMJTBW": "Пароль аккаунта будет синхронизирован",
    "DangQianZhangHao": "Текущий аккаунт",
    "QDYJZ": "Подтвердить удаление",
    "JSPSCM": "товара(ов)?",
    "ShanChuChengGong": "Удалено!",
    "SJGSCW": "Неверный телефон",
    "YXGSCW": "Неверный email",
    "WoDeZhangHao": "Мой аккаунт",
    "YouXiang": "Email",
    "ShouJi": "Телефон",
    "XingMing": "Имя",
    "XiuGaiTouXiang": "Изменить аватар",
    "JiBenXinXi": "Основная информация",
    "ZhangHaoAnQuan": "Безопасность",
    "XiuGaiMiMa": "Изменить пароль",
    "DianJiBangDing": "Привязать",
    "RYDSHTY_QL": "Если телефон утерян, смените его для безопасности",
    // Продолжение ru_RU.js
    "WBZNDZHAQ_": "Для безопасности привяжите телефон",
    "QSRNDXM": "Введите ваше имя",
    "QSRNDDH": "Введите ваш телефон",
    "QSRNDYX": "Введите email",
    "QCHCHXCXDL": "Очистка кеша требует повторного входа",
    "QingChuHuanCun": "Очистить кеш",
    "QDYQCHCM": "Подтвердить очистку кеша?",
    "TuiChuDengLu": "Выйти",
    "QieHuanZhangHao": "Сменить аккаунт",
    "LianXi": "Связаться",
    "GongSiDianHua": "Телефон компании",
    "DiZhi": "Адрес",
    "DJQMX": "Детали купона",
    "BuKeYong": "Недоступно",
    "KeYong": "Доступно",
    "ZWDJQ": "Нет купонов",
    "ZongEDu": "Общая сумма",
    "FaFangShiJian": "Дата выдачи",
    "EDYYW": "Лимит исчерпан",
    "QBSPKY": "Для всех товаров",
    "WDDJQ": "Мои купоны",
    "KYDJQ": "Доступные купоны",
    "DJQKDK": "Купоном можно оплатить",
    "CKKYSP": "Показать доступные товары",
    "BKYDJQ": "Недоступные купоны",
    "BKYYY_ZWFH": "Причина: нет подходящих товаров",
    "DQSPWSCGGT": "Нет изображений характеристик. Невозможно подобрать лампу!",
    "BoFangShiPin": "Смотреть видео",
    "Gong1GeGuiGe": "Характеристик: {num}",
    "YiXuanGuiGe": "Выбрано",
    "XuanGuiGe": "Выбрать",
    "LingQuan": "Получить купон",
    "1ZhongCuXiao": "1 акция",
    "1ZhangKeYong": "1 доступен",
    "ZuiGaoKeSheng": "Макс. экономия",
    "ShangPinTaoCan": "Набор товаров",
    "Gong1GeTaoCan": "1 набор",
    "ShangPinCanShu": "Параметры",
    "ZhanKai": "Развернуть",
    "YiShouCang": "В избранном",
    "ShouCang": "В избранное",
    "KeFu": "Поддержка",
    "XiangQing": "Описание",
    "TuiJian": "Рекомендуем",
    "BianHao": "Артикул",
    "ShangPinXinXi": "Информация",
    "KLYHQ": "Можно получить купон",
    "KuCunBuZu": "Нет в наличии",
    "DuoGuiGe": "Много характеристик",
    "YiShou": "Продано",
    "SWBHZ_YS": "Распродано, продано",
    "CuXiaoShangPin": "Акционный товар",
    "NHWSRSSNR": "Введите запрос",
    "SouSuo": "Поиск",
    "SSY1XGDSP": "Товары по запросу «{searchKey}»",
    "Yue1GeShangPin": "Товаров: ~{num}",
    "ZuiJinSouSuo": "История поиска",
    "QingChu": "Очистить",
    "ZWSSJL": "Нет истории",
    "ZGJGBNDYZD": "Макс. цена не может быть ниже мин.",
    "ShangPinBiaoQian": "Метки товара",
    "BuGaoYu1": "Не более 1",
    "BuDiYu1": "Не менее 1",
    "FengGe": "Стиль",
    "JiJiangKaiShi": "Скоро начнётся",
    "QuanBuCuXiao": "Все акции",
    "Gong1JianShangPin": "Товаров: 1",
    "Sheng": "Экономия",
    "GTCZGWCZDS": "Наборов в корзине достигло лимита",
    "GTCKCBZ_BK": "Нет в наличии. Нельзя добавить",
    "JinSheng1Tao": "Остался 1 набор",
    "XianGou1Tao": "Лимит: 1 набор",
    "TaoCanXiangQing": "Детали набора",
    "DanMaiJia": "Цена отдельно",
    "TaoCanJia": "Цена набора",
    "HDYJS": "Акция завершена",
    "WDL_QXDL": "Требуется вход",
    "YiXiaShangPin": "Следующие товары",
    "1ZhongGuiGe": "1 характеристика",
    "YouKuCun": "В наличии",
    "BuGaoYu": "До",
    "BuDiYu": "От",
    "CuXiao": "Акции",
    "ZDYXXZ3G": "Макс. 3 выбора",
    "GouMai": "Купить",
    "Gong1Jian": "Товаров: {num}",
    "DLHCKJG": "Цены после входа",
    "M1JZ1J": "За {num} шт. +{presentNum} в подарок",
    "CZPF_ZZCXC": "Повторите попытку",
    "XSZJJXZ": "Спеццена ограничена",
    "YXSPM1YZ1J_": "Товары {str}. Добавьте в корзину для скидки!",
    "TiaoXingMa": "Штрихкод",
    "XiangGuanTuiJian": "Смотрите также",
    "YSSPBKJRGW": "Предзаказ нельзя добавить. Добавлены другие товары!",
    "YSSPBKLJGM": "Предзаказ нельзя купить сразу. Удалите его!",
    "SPSLYW": "Неверное количество",
    "ShangPin1QiShou": "Мин. заказ: {num} шт.",
    "SPDGSLBNCG": "Макс. заказ: {num} шт.",
    "QRYCXZSP": "Удалить выбранное?",
    "QRYCSYSXSP": "Удалить все неактивные товары?",
    "QRYCXZSXSP": "Удалить выбранные неактивные?",
    "M1YZ1J": "За {num}₽ +{presentNum} шт.",
    "M1YJ1Y": "Скидка {money}₽ за {price}₽",
    "M1J1": "Скидка {money}₽ за {price}",
    "M1YD1Z": "Скидка {money}% за {price}₽",
    "DDM1YHZ": "Заказ от {price}₽ = подарок",
    "YiHuoZeng": "Вы получили",
    "ZG1YLXM1YZ1": "Докупите на {price}₽ = {str}",
    "ZG1JLXM1JZ1": "Докупите {num} шт. = {str}",
    "QCSXSP": "Удалить неактивные",
    "YiXuanShangPin": "Выбрано",
    "QuJieSuan": "К оплате",
    "ShiXiaoShangPin": "Неактивные товары",
    "DingDanGuanLi": "Управление заказами",
    "ZhuangTai": "Статус",
    "ShangPinChuKu": "Отгрузка",
    "DengDaiShouHuo": "Ожидает получения",
    "PeiSongXinXi": "Доставка",
    "FuKuanXinXi": "Оплата",
    "GDFKJL": "Ещё оплаты",
    "WuLiuFuJian": "Файлы доставки",
    "ZanWuFuJian": "Нет файлов",
    "YiFa": "Отправлено",
    "YingFuZongE": "Итого к оплате",
    "FuKuanShiJian": "Время оплаты",
    "ZhangHuHaoMa": "Номер счёта",
    "KeYongYuE": "Баланс доступен",
    "TianJiaChengGong": "Добавлено",
    "ShanChuDiZhi": "Удалить адрес",
    "QXZSHDZ": "Выберите адрес",
    "YiHuoZengPin": "Подарки получены",
    "YiYouHui1Yuan": "Скидка {money}₽",
    "QWSFPXX": "Заполните данные чека",
    "1ZSP": "Видов: {num}",
    "Gong": "Товаров:",
    "Jian": "шт.",
    "ShangPinJinE": "Сумма товаров",
    "YunFeiDaoFu": "Доставка оплачивается при получении",
    "QSRZQDSHRX": "Введите имя получателя",
    "QSRZQDXXDZ": "Введите адрес",
    "DBQ_MYZDDY": "Страница не найдена",
    "ShouHuoChengGong": "Получено",
    "Hi_HuanYingNin": "Здравствуйте!",
    "YiFaEWuLiu": "Отправлено e-доставкой",
    "NinDeDingDan": "Ваш заказ",
    "ZBNBHBQ": "Не используйте смайлы",
    "XMBNWK": "Введите имя",
    "XiTongSheZhi": "Настройки системы",
    "ZhangHaoXinXi": "Данные аккаунта",
    "QingShuRuXingMing": "Введите имя",
    "QWSZL_JZYG": "Заполните профиль для лучшего обслуживания",
    "QSRZQDYXGS": "Введите email",
    "QTXZQDCWXX": "Введите реквизиты для выставления счёта",
    "GXSHDZCG": "Адрес обновлён",
    "BCSHDZCG": "Адрес сохранён",
    "XinZengDiZhi": "Новый адрес",
    "QXZYQXSCDS": "Выберите товары для удаления",
    "QuXiaoShouCang": "Удалить из избранного",
    "XuanZeGuiGe": "Выберите характеристики",
    "CaiWuGuanLi": "Финансы",
    "DuiZhangMingXi": "История сверок",
    "QSRLWJL_JE": "Введите запись/сумму",
    "YiGouMai1Ci": "Куплено {count} раз",
    "6_1GouMai": "Куплено {time}",
    "TZGGXQ": "Детали уведомления",
    "ZYXSCSP": "Только видео",
    "SCSPDXBYXC": "Размер видео не более {size}",
    "YDHSP": "Заказанные товары",
    "ShangPinPinPai": "Бренд",
    "ShangPinLieBiao": "Список товаров",
    "LingShouJia": "Розничная цена",
    "YouHuiJia": "Спеццена",
    "LiJiGouMai": "Купить сейчас",
    "ZhuTu": "Основное изображение",
    "WuXianZhi": "Без ограничений",
    "XiaoJi": "Подытог",
    "SCXZSP": "Удалить выбранное",
    "QSRDDH": "Введите номер заказа",
    "QSRDDH_SPMC": "Введите номер/название товара",
    "CaoZuo": "Действие",
    "WuLiuXinXi": "Данные доставки",
    "CaoZuoLeiXing": "Тип действия",
    "CaoZuoRiZhi": "Журнал действий",
    "CaoZuoShiJian": "Время",
    "ZhangHuMingCheng": "Название счёта",
    "KaiHuYinHang": "Банк",
    "DDTJCG_XZZC": "Заказ оформлен. Осталось оплатить",
    "ZhiFuJinE": "Сумма оплаты",
    "DZFJE": "Ожидает оплаты",
    "QTXYXSMB": "Добавьте комментарий",
    "XZSKYHZH": "Выберите счёт для оплаты",
    "TiShi": "Уведомление",
    "NHY1GDDGJ1Y": "У вас {num} заказов на {money}₽",
    "QKJQHCKJXX": "Оплатите долг для новых заказов",
    "HDDDXX": "Проверьте заказ",
    "BJSHDZ": "Изменить адрес",
    "TongZhiGongGao": "Уведомления",
    "YinHangZhangHao": "Банковский счёт",
    "XiuGaiShouJi": "Изменить телефон",
    "LXRXX": "Контактная информация",
    "GSCWXX": "Финансовые реквизиты",
    "QSRKHYHMCJ": "Введите банк и отделение",
    "QSRYHZH": "Введите номер счёта",
    "PiLiangCaoZuo": "Массовые действия",
    "GouMaiJiLu": "История покупок",
    "TongZhiBiaoTi": "Заголовок уведомления",
    "FaBuShiJian": "Дата публикации",
    "XiaoXiLeiXing": "Тип уведомления",
    "XiaoXiNeiRong": "Содержание",
    "JieShouShiJian": "Время получения",
    "QuanBuPinPai": "Все бренды",
    "WXSYS_DHGBJ": "Отсканируйте для заказа",
    "GZWXGZH": "Подписаться в WeChat",
    "FuWuReXian": "Горячая линия",
    "SouSuoLiShi": "История поиска",
    "QuanBuShanChu": "Очистить всё",
    "NH_HYLDYSDH": "Здравствуйте, {company}!",
    "ZSJDH": "Заказ с телефона",
    "SYS_GZWXGZH": "Подпишитесь в WeChat",
    "GuanZhuWoMen": "Подписаться",
    "QBSPFL": "Все категории",
    "QuPeiDeng": "Подобрать лампу",
    "KuanXiang": "Платежи",
    "QSRSPMC_GG_": "Введите название/характеристики/артикул",
    "NH_HYLDYSD": "Добро пожаловать в 云上订货!",
    "ReXiao": "Популярное",
    "20Tiao_Ye": "20 на страницу",
    "ShiChangJia_": "Рыночная цена:",
    "_134.10Qi": "От 134.10 соль",
    "HJ_BHYF": "Итого (без доставки):",
    "QDSCXZSP_": "Удалить выбранные товары?",
    "QDQCXJSP_": "Удалить снятые с продажи?",
    "DDTJCG_XZZ": "Заказ оформлен. Осталось оплатить!",
    "XuanZeZhangHu": "Выберите счёт",
    "DaiZhiFu": "Ожидает оплаты",
    "CaiGouDingDan": "Закупка",
    "DingDanXinXi": "Информация о заказе",
    "TuiChu": "Выход",
    "KaiHuMingCheng": "Название счёта",
    "QSRKHMC": "Введите название счёта",
    "_QTXZQDCWX": "(Введите реквизиты для выставления счёта)",
    "ShouHuoRen": "Получатель",
    "SWMRSHDZ": "Сделать адресом по умолчанию",
    "TianJiaDiZhi": "Добавить адрес",
    "Gong4GeGuiGe": "Характеристик: 4",
    "Zhi": "шт.",
    "Kuai": "шт.",
    "Tou": "шт.",
    "Xiang": "коробка",
    "Ping": "бутылка",
    "KaiShiRiQi": "Дата начала",
    "JieShuRiQi": "Дата окончания",
    "YiXuan": "Выбрано",
    "ZhiFuZhuangTai": "Статус оплаты",
    "QDLCKJG": "Войдите для просмотра цен",
    "YZMBZQ": "Неверный код",
    "ZhiFuJiLu": "История оплат",
    "ShangPinMingCheng": "Название товара",
    "DingGouShuLiang": "Заказано",
    "TuiHuoShuLiang": "Возвращено",
    "QSRTHNR": "Причина возврата",
    "SCTHSM": "Загрузить объяснение",
    "ShenQingShiJian": "Дата запроса",
    "ShenQingJinE": "Запрошенная сумма",
    "TuiHuoYuanYin": "Причина возврата",
    "TuiHuoShuoMing": "Объяснение",
    "TuiDanHao": "Номер возврата",
    "SXCZ_XDCG": "Кредит одобрен. Заказ оформлен",
    "SXEDBZ_FKHFH": "Недостаточно кредита. Оплатите для отправки",
    "CGJKZQ_FKFH": "Просрочен кредит. Оплатите для отправки",
    "DDTJCG_XZZCZHYB": "Заказ оформлен. Осталось оплатить!",
    "QNZ_NWCFK_FZ": "Оплатите в течение {time}, иначе заказ отменится.",
    "MianFeiLing": "Бесплатно",
    "M_KMFLQ_HQ": "Бесплатный товар за {target}₽. Осталось {short}₽",
    "YHDMFSP": "Вы получили бесплатный товар",
    "JRMFL": "Бесплатно сегодня",
    "LingGuangLe": "Закончилось",
    "KeLingQu": "Можно получить",
    "QSRZFJE": "Введите сумму",
    "QNJKFK_WMJKWNCL": "Оплатите для обработки заказа!",
    "XianXiaTiYanGuan": "Шоурум",
    "QingXuanZheSheng": "Выберите область",
    "QingXuanZheShi": "Выберите город",
    "ZhanGuanDiZhi": "Адрес шоурума",
    "YingYeShiJian": "Часы работы",
    "ZhanGuanDianHua": "Телефон шоурума",
    "FenXiang": "Поделиться",
    "TiYanGuanJieShao": "О шоуруме",
    "DPYDY_QSHX": "Магазин закрыт. Зайдите позже",
    "DaYangShiJian": "Время закрытия",
    'IMEI': 'IMEI',
    "FanKuanYuE": "Кэшбэк",
    "FanKuanZhiFu": "Оплата кэшбэком",
    "YiShengZhiFu": "EasyPay",
    "JiongDongShouYinTai": "JD Pay",
    "FKYEBZ": "Недостаточно кэшбэка",
    "FanKuanZhangHu": "Счёт кэшбэка",
    "HaiXuZhiFu": "Осталось оплатить {price}",
    "FaPiaoMingXi": "Детали счёта",
    "FaPiaoZhuShou": "Помощник по счетам",
    "WoDeFaPiao": "Мои счета",
    "FaPiaoXiangQing": "Детали счёта",
    "KaiPiaoShiJian": "Дата выставления",
    "DaiKaiFaPiao": "Ожидает выставления",
    "DKFPJE": "Ожидает выставления",
    "KaiPiaoJinE": "Сумма счёта",
    "GuanLianDanHao": "Связанный номер",
    "ChuangJianShiJian": "Дата создания",
    "ZhiFuPingZheng": "Подтверждение оплаты",
    "QSRZQNR": "Введите корректные данные",
    "QSRTDH_SPMC": "Введите номер возврата/товар",
    "ShangPinRuKu": "Приём товара",
    "TuiKuanChuLi": "Обработка возврата",
    "YuanDingDanHao": "Исходный номер заказа",
    "TuiHuoXinXi": "Информация о возврате",
    "TuiKuanXinXi": "Информация о возврате средств",
    "TuiKuanZhuangTai": "Статус возврата",
    "ZWTKJL": "Нет возвратов",
    "GDTKJL": "Ещё возвраты",
    "DDDKFQRBJQSH": "Ожидание подтверждения цены",
    "BNSRDYHDTSZF": "Не используйте спецсимволы",
    "THSLBNWK": "Введите количество",
    "BZBNBHBQ": "Не используйте смайлы в примечании",
    "THSLBKDYKTHSL": "Количество превышает доступное",
    "DDM_YZ_J": "Заказ от {target}₽ = +{number} шт.",
    "M_JZ_J": "За {target} шт. = +{number} шт.",
    "M_JJZ_Y": "За {target} шт. = {money}₽",
    "YDHJJZ_Y": "Скидка до {price}₽",
    "M_JD_Z": "За {number} шт. = скидка {percent}%",
    "YDHJD_Z": "Скидка {percent}%",
    "WDSYT": "Моя касса",
    "ZZSYMPSMJY": "Оплата через Mercado Pago",
    "SKF": "Получатель",
    "SYSFK": "Отсканируйте для оплаты",
    "DDXQ": "Детали заказа",
    "YUAN": 'RUB',
    "GXNHQ_Z_Y_": "Вы получили {num} купонов {price}₽ {name}",
    "QBLX": "Все типы",
    "QLQZX": "В центр купонов",
    "YLYH": "Получено",
    "MZTJJKSY": "Условия выполнены",
    "GXNHD_Z_YHQ": "Вы получили {num} купонов",
    "G_Y": "Сумма: {price}₽",
    "XZYHQ": "Выбрать купон",
    "PLXD": "Массовый заказ",
    "FHJL": "История отправок",
    "DDTJ": "Статистика заказов",
    "DDGL": "Управление заказами",
    "JKWFH": "Только неотправленные",
    "DDS": "Заказов",
    "DGSPS": "Товаров заказано",
    "THSPS": "Товаров возвращено",
    "YFHSPS": "Товаров отправлено",
    "WFHSPS": "Товаров не отправлено",
    "YFHSPJE": "Сумма отправленных",
    "WFHSPJE": "Сумма неотправленных",
    "WFH": "Не отправлено",
    "YGJ": "Предв. цена",
    "GGBM": "Код характеристики",
    "SLHJ": "Итого количество",
    "JEHJ": "Итого сумма",
    "QPLKY": "Для всех товаров",
    "KYCXHDDJSY": "Можно комбинировать с акциями",
    "BKDKYF": "Не включает доставку",
    "SYHBYTH": "Не возвращается после использования",
    "TiJi": "Объём",
    "ZhongLiang": "Вес",
    "ZongTiJi": "Общий объём",
    "ZongZhongLiang": "Общий вес",
    "QSRDHDCKDWLDHSJRSJH": "Введите номер/отгрузки/доставки/получателя/телефон",
    "CKDH": "Номер отгрузки",
    "WLDZT": "Статус доставки",
    "WLDH": "Трек-номер",
    "SJR": "Получатель"
};
export default ru_RU;
